<div id="loader">
    <div>
        <h2>CARGANDO...</h2>
    </div>
</div>